import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" style={{
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round"
  }} viewBox="-7 -7 45 45"><path d="M6.616 23.364c.226.227.46.442.7.646m-.7-17.394c4.625-4.625 12.123-4.625 16.748 0 4.625 4.625 4.625 12.123 0 16.748a11.833 11.833 0 01-2.881 2.121M6.616 6.616l6.119-.322m-6.119.322l2.558-5.411m.323 24.28c.775.406 1.586.72 2.416.943m2.777.401a11.906 11.906 0 003.126-.337" style={{
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 2
    }} /></svg>;
}
export default SvgComponent;